import React from 'react';
import { useParams } from 'react-router-dom';
import AssessmentsView from './AssessmentsView';

/**
 * Wrapper component that extracts assessmentId from route params
 * and passes it to AssessmentsView as a prop
 */
export default function AssessmentsViewWrapper({ Component=AssessmentsView, ...rest } ) {
    const { assessmentId } = useParams();

    return <Component {...rest} assessmentId={assessmentId} />;
}

